module.exports = __webpack_public_path__ + "static/media/007-star-red.40bc03c4.svg";